<template>
  <b-alert
    variant="warning"
    v-if="$store.state.profile.isOffline"
    dismissible
    fade
    :show="!isHide"
    @dismissed="isHide = true"
  >
    <div class="alert-body text-center">
      {{ $t("alert.activatedOfflineMode") }}
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BLink, BSpinner } from "bootstrap-vue";

export default {
  components: {
    BAlert,
    BLink,
    BSpinner,
  },
  data() {
    return {
      isHide: false,
    };
  },
};
</script>